import React from 'react';

const CapsuleStatusCell = ({ row }) => {
  const issueStatus = row.issueStatus || row.status || '';
  const reviewStatus = row.reviewStatus || row.video_status || '';
  const capsuleStatus = row.capsuleStatus || row.NBA_status || '--';

  const issueCode = String(row.issueStatusCode || '').toUpperCase();
  const reviewCode = String(row.reviewStatusCode || '').toUpperCase();
  const capsuleCode = String(row.capsuleStatusCode || '').toUpperCase();

  const hasIssue =
    Boolean(issueStatus) &&
    issueCode !== 'NO_ISSUE' &&
    issueStatus !== 'No Issue' &&
    issueStatus !== 'Pending Transcode';

  const isCapsuleAvailableToCustomer =
    capsuleCode === 'VIDEO_AVAILABLE_TO_CUSTOMER' ||
    capsuleStatus === 'Video Available to Customer' ||
    capsuleStatus === 'Success';

  const preTranscodeCapsuleCodes = new Set(['RECEIVED_IN_DLC', 'UPLOADING_FROM_DLC', 'RECEIVED_IN_AWS']);
  const preTranscodeCapsuleNames = new Set(['Received in DLC', 'Uploading from DLC', 'Received in AWS']);
  const isCapsulePreTranscode =
    preTranscodeCapsuleCodes.has(capsuleCode) ||
    preTranscodeCapsuleNames.has(capsuleStatus);

  const hasVideoSignal = Boolean(
    row.videoPath ||
    row.video_path ||
    row.videoBucket ||
    row.video_bucket ||
    row.transcodeTime ||
    row.transcode_date ||
    row.transcode_time ||
    isCapsuleAvailableToCustomer
  );

  const isReviewApproved = reviewCode === 'APPROVED' || reviewStatus === 'Approved';
  const isReviewRejected = reviewCode === 'REJECTED' || reviewStatus === 'Rejected';
  const showReviewStatus = !isCapsulePreTranscode && hasVideoSignal && (isReviewApproved || isReviewRejected);

  const statusItems = [];
  if (hasIssue) {
    statusItems.push({
      key: 'issue',
      label: 'Issue Status',
      value: issueStatus,
      valueClass: 'text-red-600 font-bold',
    });
  }

  statusItems.push({
    key: 'capsule',
    label: 'Capsule Status',
    value: capsuleStatus,
    valueClass: isCapsuleAvailableToCustomer ? 'text-green-600 font-bold' : 'text-blue-600',
  });

  if (showReviewStatus) {
    statusItems.push({
      key: 'review',
      label: 'Review Status',
      value: reviewStatus,
      valueClass: isReviewApproved ? 'text-green-600 font-bold' : 'text-red-600 font-bold',
    });
  }

  return (
    <div className="w-full py-2 text-sm leading-tight text-left">
      {statusItems.map((item, index) => (
        <div
          key={item.key}
          className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border border-gray-200 rounded px-2 py-1 mb-1`}
        >
          <span className="font-semibold text-gray-500 mr-1">{item.label}:</span>
          <span className={item.valueClass}>{item.value}</span>
        </div>
      ))}

      {row.RMA_status && (
        <div className="mt-1 border-t pt-1 border-gray-200 text-left">
          <span className="text-red-600 font-bold block text-xs uppercase tracking-wide">
            Investigation Note:
          </span>
          
          {row.RMA_note ? (
            <span className="text-gray-800 block break-words whitespace-normal max-w-xs">
              {row.RMA_note}
            </span>
          ) : (
            <span className="text-gray-400 italic">N/A</span>
          )}
        </div>
      )}
    </div>
  );
};

export default CapsuleStatusCell;
